import { connect } from 'react-redux';
import modal from 'decorators/Modal/Modal';
import { withSagas } from 'decorators/Sagas/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { deepExtract } from 'helpers/deep';
import { selectUserCredits } from 'redux/saga/helpers/credit-cycle';
import { createReservation, userProfile, userActionCampaignEvent } from 'redux/saga/entities/bound';
import { requestReservation, watchRequestReservation } from '../Reservation.saga';
import { cleanupReservationModal } from './ReservationModal.saga';
import { ReservationModalFlow } from './ReservationModalFlow';
var modalConfig = {};
export var mapStateToProps = function mapStateToProps(state) {
  var reservation = createReservation.select(state);
  var user = userProfile.data(state);
  var userCredits = selectUserCredits(state);
  return {
    creditsBalance: deepExtract('credits_remaining', userCredits),
    endOfCycleDate: deepExtract('membership.cycle_end', user),
    msaTimeZone: user.msa && user.msa.timezone,
    referral: userActionCampaignEvent.data(state, userActionCampaignEvent.lastRequestedKey(state)),
    isReservationLoading: reservation.loading,
    isReservationLoaded: reservation.loaded,
    isReservationError: reservation.error,
    isReferralLoading: userActionCampaignEvent.loading(state, userActionCampaignEvent.lastRequestedKey(state)),
    isReferralError: userActionCampaignEvent.error(state, userActionCampaignEvent.lastRequestedKey(state))
  };
};
export var mapDispatchToProps = {
  onReservationRequest: requestReservation
};
export var ReservationModalContainer = decorateWith(modal(modalConfig), withSagas({
  cleanup: cleanupReservationModal,
  watch: watchRequestReservation
}), connect(mapStateToProps, mapDispatchToProps), withName('ReservationModal'))(ReservationModalFlow);